import * as requests from '../api-request'

const pendingListSourceRequests = new Map()

export const listFolders = async (workspaceId) => {
  return requests.toJSON('GET', `knowledge/workspaces/${workspaceId}/folders`)
}

export const createFolder = async (workspaceId, data) => {
  return requests.toJSON('POST', `knowledge/workspaces/${workspaceId}/folders`, data)
}

export const updateFolder = async (workspaceId, folderUuid, data) => {
  return requests.toJSON('PATCH', `knowledge/workspaces/${workspaceId}/folders/${folderUuid}`, data)
}

export const archiveFolder = async (workspaceId, folderUuid) => {
  return requests.toJSON('POST', `knowledge/workspaces/${workspaceId}/folders/${folderUuid}/archive`)
}

export const deleteFolder = async (workspaceId, folderUuid) => {
  return requests.toJSON('DELETE', `knowledge/workspaces/${workspaceId}/folders/${folderUuid}`)
}

export const listSources = (workspaceId, filters = {}) => {
  const query = requests.createQueryString(filters).toString()
  const suffix = query ? `?${query}` : ''
  const requestKey = `${workspaceId}:${suffix}`
  if (pendingListSourceRequests.has(requestKey)) return pendingListSourceRequests.get(requestKey)

  const request = requests.toJSON('GET', `knowledge/workspaces/${workspaceId}/sources${suffix}`)
    .finally(() => {
      pendingListSourceRequests.delete(requestKey)
    })
  pendingListSourceRequests.set(requestKey, request)
  return request
}

export const previewSource = async (workspaceId, sourceUuid) => {
  return requests.toBlob('GET', `knowledge/workspaces/${workspaceId}/sources/${sourceUuid}/preview`)
}

export const deleteSources = async (workspaceId, sourceUuids) => {
  return requests.toJSON('POST', `knowledge/workspaces/${workspaceId}/sources/delete`, { sourceUuids })
}

export const uploadSource = async (workspaceId, { file, folderUuid, projectUuid, relativePath }) => {
  const formData = new FormData() // eslint-disable-line no-undef
  formData.append('file', file)
  formData.append('folderUuid', folderUuid)
  if (projectUuid) {
    formData.append('projectUuid', projectUuid)
  }
  if (relativePath) {
    formData.append('relativePath', relativePath)
  }
  return requests.toJSON('POST', `knowledge/workspaces/${workspaceId}/upload`, formData, null, false)
}

export const listBindings = async (workspaceId, filters = {}) => {
  const query = requests.createQueryString(filters).toString()
  const suffix = query ? `?${query}` : ''
  return requests.toJSON('GET', `knowledge/workspaces/${workspaceId}/bindings${suffix}`)
}

export const createBinding = async (workspaceId, data) => {
  return requests.toJSON('POST', `knowledge/workspaces/${workspaceId}/bindings`, data)
}

export const deleteBinding = async (workspaceId, bindingUuid) => {
  return requests.toJSON('DELETE', `knowledge/workspaces/${workspaceId}/bindings/${bindingUuid}`)
}
